module.exports = __webpack_public_path__ + "img/layout-11_1.08d261cc.png";